var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titled-list"},[_c('p',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"titled-list-item",domProps:{"textContent":_vm._s(item)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }